export default {
  'menu.home': 'Home',
  'menu.route.Index': 'Home',
  'menu.route.Center': 'Profile',
  'menu.route.Settings': 'Account Settings',
  'menu.route.ZrInfo': 'SMS Settings',
  'menu.route.JobLog': 'Job Logs',
  'menu.route.AuthUser': 'Assign Users',
  'menu.route.NoticeForm': 'Notice Editor',
  'menu.route.GenEdit': 'Edit Generator Config',
  'menu.route.System': 'System',
  'menu.route.Monitor': 'Monitor',
  'menu.route.Tool': 'Tools',
  'menu.route.User': 'Users',
  'menu.route.Role': 'Roles',
  'menu.route.Menu': 'Menus',
  'menu.route.Dept': 'Departments',
  'menu.route.Post': 'Posts',
  'menu.route.Config': 'Parameters',
  'menu.route.Notice': 'Notices',
  'menu.route.Log': 'Logs',
  'menu.route.Server': 'Server Monitor',
  'menu.route.Cache': 'Cache Monitor',
  'menu.route.CacheList': 'Cache List',
  'menu.route.Gen': 'Code Generator',
  'menu.route.Swagger': 'API Docs',
  'menu.route.Operlog': 'Operation Logs',
  'menu.route.Logininfor': 'Login Logs',
  'menu.route.Pay': 'Payments',
  'menu.route.Pay/channel': 'Payment Channels',
  'menu.route.Pay/order': 'Payment Orders',
  'menu.route.Pay/orderrefund': 'Refund Orders',
  'menu.route.Dbdoc': 'Database Docs',
  'menu.route.App/user': 'App Users',
  'menu.route.Biz': 'User Info',
  'menu.route.Cancel': 'Account Cancellation',
  'menu.route.Banner': 'Banners',
  'menu.route.Yunying': 'Operations',
  'menu.route.Baozhuangguanli': 'Packaging',
  'menu.route.Category': 'Categories',
  'menu.route.Goods': 'Products',
  'menu.route.Spec': 'Specifications',
  'menu.route.Machine': 'Machine Meters',
  'menu.route.PrintMultiples': 'Print Multiples',
  'menu.route.CuttingTool': 'Cutting Tools',
  'menu.route.Order': 'Orders',
  'menu.route.GoodsOrder': 'Orders',
  'menu.route.HomeNotice': 'Home Notices',
  'menu.route.Feedback': 'Feedback',
  'menu.route.Transportation': 'Shipping Methods',
  'menu.route.SpecialMultiple': 'Special Multiples',
  'menu.route.ToolMagazine': 'Tool Magazine',
  'menu.route.OrderSettlement': 'Settlement Orders',
  'menu.names.首页': 'Home',
  'menu.names.个人中心': 'Profile',
  'menu.names.个人设置': 'Account Settings',
  'menu.names.短信设置': 'SMS Settings',
  'menu.names.调度日志': 'Job Logs',
  'menu.names.分配用户': 'Assign Users',
  'menu.names.公告编辑': 'Notice Editor',
  'menu.names.修改生成配置': 'Edit Generator Config',
  'menu.names.系统管理': 'System',
  'menu.names.系统监控': 'Monitor',
  'menu.names.系统工具': 'Tools',
  'menu.names.用户管理': 'Users',
  'menu.names.角色管理': 'Roles',
  'menu.names.菜单管理': 'Menus',
  'menu.names.部门管理': 'Departments',
  'menu.names.岗位管理': 'Posts',
  'menu.names.参数设置': 'Parameters',
  'menu.names.通知公告': 'Notices',
  'menu.names.日志管理': 'Logs',
  'menu.names.服务监控': 'Server Monitor',
  'menu.names.缓存监控': 'Cache Monitor',
  'menu.names.缓存列表': 'Cache List',
  'menu.names.代码生成': 'Code Generator',
  'menu.names.系统接口': 'API Docs',
  'menu.names.操作日志': 'Operation Logs',
  'menu.names.登录日志': 'Login Logs',
  'menu.names.支付管理': 'Payments',
  'menu.names.支付渠道': 'Payment Channels',
  'menu.names.支付订单': 'Payment Orders',
  'menu.names.退款订单': 'Refund Orders',
  'menu.names.数据库文档': 'Database Docs',
  'menu.names.用户信息': 'User Info',
  'menu.names.用户注销': 'Account Cancellation',
  'menu.names.广告管理': 'Banners',
  'menu.names.运营管理': 'Operations',
  'menu.names.包装管理': 'Packaging',
  'menu.names.分类管理': 'Categories',
  'menu.names.产品管理': 'Products',
  'menu.names.规格管理': 'Specifications',
  'menu.names.调机米数': 'Machine Meters',
  'menu.names.印刷倍数': 'Print Multiples',
  'menu.names.刀具费用': 'Cutting Tools',
  'menu.names.订单管理': 'Orders',
  'menu.names.首页通知': 'Home Notices',
  'menu.names.意见反馈': 'Feedback',
  'menu.names.运输方式': 'Shipping Methods',
  'menu.names.特殊倍数': 'Special Multiples',
  'menu.names.刀库管理': 'Tool Magazine',
  'menu.names.结算订单': 'Settlement Orders'
}
